import React from 'react';
import ReleaseCard from './ReleaseCard';

export default function ReleaseV170({ createClickableListItem, createThumbnail }) {
  return (
    <ReleaseCard version="v1.7.0" date="21st October 2025" title="Only one update for this version, but it's significant enough to warrant its own release!">
      <p className="text-gray-300 mb-4">Here's what's new:</p>
      <ul className="text-gray-400 space-y-2 mb-4">
        {createClickableListItem('Added summary card on venue front page displaying top three players for last month\'s statistics', '/v1.7.0/league1.jpg')}
        {createClickableListItem('See stats by month, quarter, or year', '/v1.7.0/league2.jpg')}
        {createClickableListItem('Drill down to see detailed individual player statistics', '/v1.7.0/league3.jpg')}
      </ul>
      <div className="mb-4">
        <p className="text-gray-300 mb-2 text-sm">This releases screenshots:</p>
        <div className="flex flex-wrap gap-4">
          {createThumbnail('/v1.7.0/league1.jpg', 'Detailed league tables based on weekly game reports feature preview')}
          {createThumbnail('/v1.7.0/league2.jpg', 'Detailed league tables based on weekly game reports feature preview')}
          {createThumbnail('/v1.7.0/league3.jpg', 'Detailed league tables based on weekly game reports feature preview')}
        </div>
      </div>
      <p className="text-gray-300 mb-4">Substantial effort went into this release, you asked for it…. we delivered!</p>
      <p className="text-gray-300 mb-4">Automatic league tables now generated from your regular weekly game reports. Simply fill out the game report at the end of each game, and monthly, quarterly, and annual reports will provide in-depth insights into your venue's games.</p>
      <p className="text-gray-300 mb-4">A summary card on your venue's front page displays the top three players for the last month's statistics. From there, you can access the full report and explore each registered user's statistics, including their placement in each game and their prizes. All of this is free; the admin just needs to complete a game report each week—simple but effective! We think you'll agree!</p>
    </ReleaseCard>
  );
}
